import axios from "../lib/axios"; 

const UnLock = async (DocId,tableName, CWhere) => {
    const UserId = sessionStorage.getItem("UserId");
    try {
        let response = await axios.post(
            `Lock/UpdateLock`,
            {
                "tblName": tableName,
                "LockSt": "0",
                "LockId": parseInt(UserId),
                "Cwhere": CWhere,
                "LockDt": "2024-11-27 17:30:01.743",
                "DocId": DocId,
                "Flag": "",
                "ColName": "LockSt",
                "ColName1": "LockId",
                "ColName2": "LockDt"
            }
        );

        if (response.data.Status === 0) {
            // setMode("view");
            // setAllButtonTextDisabled(prev => !prev); 
            // toast.info(response.data.Message);
            return 0;
        }else{
             return 1;
        }
    }
    catch (err) {
        console.log("err", err);
    }
}

export default UnLock;  